import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './healthInfo.css';

import { HealthInformation } from '../../components/healthInformation';

const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div style={{ paddingTop: '1em' }}>
      <center>
          <Link to='/' style={{ padding: '.2em' }}>
            <span>
              {t("Main Page")}
            </span>
          </Link>
      </center>
    </div>
  );
}

export const HealthInfo: React.FC = () => {
  return (
    <div>
      <Header />
      <HealthInformation />
    </div>
  );
}
